import styled from "styled-components";
import type { FieldGroupRowProps } from "./registration-page.types";

export const FieldGroupRow = styled.div<FieldGroupRowProps>`
  display: flex;
  justify-content: space-between;
  gap: ${({ gap }) => `${gap}px`};
`;

export const FieldGroupWrapper = styled.div`
  margin-bottom: 36px;
`;

export const CheckBoxGroup = styled.div`
  margin-bottom: 36px;
  & > div {
    margin-bottom: 16px;
  }
`;

export const SocialAuthRegistration = styled.div`
  position: relative;
  top: 40px;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`;

export const RegistartionForm = styled.div`
  width: 65%;

  & form {
    max-width: 744px;
  }
`;
